<template>
  <div>
    <div class="bg-white shadow p-8 rounded flex flex-wrap items-center">
      <!--GB asked that we remove the profile card here. Leaving it commented out in-case they ever want it back-->
      <!--<div :class="[fullWidth ? 'w-1/2' : 'w-full']">
        <div class="flex justify-center">
          <d-avatar :img-src="content.authorProfilePictureUrl" :text="content.authorName" :size="fullWidth ? 100 : 150" />
        </div>
        <p class="text-center text-3xl mt-5">
          {{ content.authorName }}
        </p>
        <hr v-if="!fullWidth">
      </div>-->
      <div :class="[fullWidth ? 'w-1/2' : 'w-full']">
        <div class="mb-2 font-bold text-xl leading-tight">
          Lesson Details
        </div>
        <div v-if="content.completionLength" class="mb-5">
          <p class="text-gray-700 leading-tight">
            Completion Hours
          </p>
          <p class="font-bold text-lg leading-tight">
            {{ content.completionLength }}
          </p>
        </div>
        <div>
          <p class="text-gray-700 leading-tight">
            Last Modified
          </p>
          <p class="font-bold text-lg leading-tight">
            {{ $format.formatDate(content.lastModifiedDate) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      content: {
        type: Object,
        default: () => ({}),
      },

      fullWidth: Boolean,
    },
  };
</script>